import React, { useMemo } from 'react';
import IconContext from '@ant-design/icons/es/components/Context';
import { getCspNonce } from '../utils/getCspNonce';

/**
 * Supplies CSP nonce to @ant-design/icons so rc-util injects <style> tags with nonce="…".
 */
export default function AntDesignIconsCspProvider({ children }) {
  const iconContextValue = useMemo(() => {
    const nonce = getCspNonce();
    return nonce ? { csp: { nonce } } : {};
  }, []);

  return (
    <IconContext.Provider value={iconContextValue}>
      {children}
    </IconContext.Provider>
  );
}
